<template>
  <a-drawer
    title="商品编辑11"
    :width="1500"
    :visible="visible"
    :footer="null"
    @close="handleClose"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left" :model="form"
                    :rules="rules">
        <a-collapse v-model="activeKey">
          <a-collapse-panel key="1" :header="$t('商品.基础信息')" class="goods-collapse">
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" :label="$t('商品.商品名称')" prop="goodsName">
                  <a-input v-model="form.goodsName" :maxLength="128" :placeholder="$t('通用.输入.请输入')+$t('商品.商品名称')"/>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.商品分类')" prop="categoryId">
                  <a-cascader :options="categoryListPlat"
                              :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                              :placeholder="$t('通用.输入.请输入')+$t('商品.商品分类')"
                              style="width: 100%" v-model="categorySelected" allowClear @change="onCategoryChange">
                  </a-cascader>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="this.$t('商品.商品主图')" prop="picture">
                  <OssUploadSingle v-model="form.picture" type="img" :maxSize="200"></OssUploadSingle>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.商品轮播图')" prop="imgList">
                  <OssUploadMulti v-model="form.imgList" :isArrayData="true" :max-count="5" :prefix="goods" type="img" :draggable="true"></OssUploadMulti>
                  <div class="color-gray" style="font-size: 12px; margin-top: 4px;">拖动图片可调整轮播顺序</div>
                </a-form-model-item>
<!--                <a-form-model-item :label="$t('商品.商品轮播图')" prop="imgList">-->
<!--                  <OssUploadMulti v-model="form.imgList" :isArrayData="true" :max-count="5" :prefix="goods" type="img"></OssUploadMulti>-->
<!--                </a-form-model-item>-->
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="this.$t('商品.商品视频')" prop="video">
                  <OssUploadSingle v-model="form.video" type="video" :prefix="goods" :maxSize="200"></OssUploadSingle>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.品牌')" prop="brandId">
                  <a-select style="width: 100%" v-model="form.brandId" placeholder="请选择品牌"
                            allowClear
                            :filter-option="false" :show-arrow="false" :not-found-content="null"
                            :default-active-first-option="false"
                            show-search
                            @search="handleBrandSearch"
                            @change="handleBrandChange">
                    <a-select-option v-for="(item, index) in brandList" :value="item.id" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.是否推荐')" prop="isRecommend">
                  <a-radio-group v-model="form.isRecommend" button-style="solid">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>

            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="3" :header="$t('商品.规格信息')" class="goods-collapse" v-if="form.skuList && form.skuList.length > 0">
            <a-table :data-source="form.skuList" :columns="skuColumns" rowKey="id"
                     :pagination="false" bordered>
              <div slot="skuWeight" slot-scope="text, record">
                <a-input v-model="record.weight" :placeholder="$t('通用.输入.请输入')+$t('商品.商品重量')"
                         @blur.native.capture="validatorSku"/>
              </div>
              <template slot="skuPicture" slot-scope="text, record">
                <div>
                  <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" alt="none"/>
                </div>
              </template>
            </a-table>
            <span style="color: red;" v-if="skuErrorMessage">{{ skuErrorMessage }}</span>
          </a-collapse-panel>
          <a-collapse-panel key="4" :header="$t('商品.商品详情')" class="goods-collapse">
            <a-row style="height: 30px">
              <a-col></a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}" :label="$t('商品.商品详情')"
                                   prop="description">
                  <editor v-model="form.description" :placeholder="$t('通用.输入.请输入')+$t('商品.商品详情')"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <!-- 按钮组 -->
        <div style="margin-top: 20px; text-align: right;">
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="margin-left: 8px;">
            保存
          </a-button>
        </div>
      </a-form-model>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl"/>
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      </a-spin>
    </a-drawer>
</template>

<script>
import { getGoods, updateGoods } from '@/api/goods/goods'
import {listCategoryPlat} from "@/api/goods/category";
import {allBrand, listBrand} from "@/api/goods/brand"
import {mapGetters} from 'vuex'
import {uploadObject, uploadOss} from "@/api/tool/oss";
import Editor from '@/components/Editor'
import OssUploadSingle from "@/components/OssUploadSingle";
import OssUploadMulti from "@/components/OssUploadMulti";

export default {
  name: 'EditDrawer',
  components: {
    Editor,
    OssUploadSingle,
    OssUploadMulti,
  },
  data() {
    return {
      tabIndex: 1,
      visible: false,
      loading: false,
      submitLoading: false,
      categoryListPlat: [{id: "0", categoryName: '', children: []}],
      categoryListShop: [{id: "0", categoryName: '', children: []}],
      crossCategoryList: [{id: "0", categoryName: '', children: []}],
      brandList: [],
      packageIdList: [],
      labelList: [],
      isSpecPic: false,
      categorySelected: [],
      categorySelectedShop: [],
      crossCategorySelected: [],
      labelCol: {span: 4},
      activeKey: [1, 3, 4],
      wrapperCol: {span: 16},
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      skuLoading: false,
      imgList: [],
      skuErrorMessage: undefined,
      errorMessage: undefined,
      skuColumns: [
        {
          title: this.$t('商品.sku.名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        },
        {
          title: this.$t('商品.sku.重量'),
          dataIndex: 'weight',
          key: 'weight',
          scopedSlots: {customRender: 'skuWeight'}
        }, {
          title: this.$t('商品.sku.图片'),
          dataIndex: 'picture',
          key: 'picture',
          scopedSlots: {customRender: 'skuPicture'}
        }
      ],
      specDisable: false,
      shopId: null,
      form: {},
      rules: {
        goodsName: [
          {required: true, message: this.$t('商品.商品名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        goodsType: [
          {required: true, message: this.$t('商品.商品类型') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        picture: [
          {required: true, message: this.$t('商品.商品主图') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        isMultipleSpec: [
          {required: true, message: this.$t('商品.是否多规格') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        status: [
          {required: true, message: this.$t('商品.商品状态') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        specName: [
          {required: true, message: this.$t('商品.规格.规格名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    // 打开抽屉
    open(id) {
      this.visible = true
      this.loading = true
      this.loadData()
      this.getGoodsDetail(id)
    },
    // 加载数据
    loadData() {
      Promise.all([
        this.getCategoryList(),
        this.getCategoryListShop(),
        this.getCrossCategoryList(),
        this.getBrandList()
      ]).finally(() => {
        this.loading = false
      })
    },
    // 获取商品详情
    getGoodsDetail(id) {
      getGoods({id: id}).then(response => {
        this.form = response.data
        if (this.form.categoryId) {
          // 等待分类列表加载完成后回显
          this.$nextTick(() => {
            this.categorySelected = this.findCategoryPath(this.categoryListPlat, this.form.categoryId)
          })
        } else {
          this.categorySelected = []
        }
      }).catch(error => {
        console.error('获取商品详情失败:', error)
        this.loading = false
      })
    },
    // 查找分类路径
    findCategoryPath(tree, targetId, path = []) {
      for (const node of tree) {
        const currentPath = [...path, node.id]
        if (node.id === targetId) {
          return currentPath
        }
        if (node.children && node.children.length > 0) {
          const foundPath = this.findCategoryPath(node.children, targetId, currentPath)
          if (foundPath) {
            return foundPath
          }
        }
      }
      return null
    },
    getCategoryList() {
      return listCategoryPlat().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.categoryListPlat = children
      }).catch(error => {
        console.error('获取平台分类失败:', error)
        this.$message.error('获取平台分类失败')
      })
    },
    getCategoryListShop() {
      return listCategoryPlat().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.categoryListShop = children
      }).catch(error => {
        console.error('获取店铺分类失败:', error)
        this.$message.error('获取店铺分类失败')
      })
    },
    getCrossCategoryList() {
      return listCategoryPlat().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.crossCategoryList = children
      }).catch(error => {
        console.error('获取跨境分类失败:', error)
        this.$message.error('获取跨境分类失败')
      })
    },
    getBrandList() {
      return allBrand().then(response => {
        this.brandList = response.data;
      }).catch(error => {
        console.error('获取品牌列表失败:', error)
        this.$message.error('获取品牌列表失败')
      })
    },
    handleBrandSearch(value) {
      listBrand({name: value}).then(response => {
        this.brandList = response.data;
      })
    },
    handleBrandChange(value) {
      this.form.brandId = value
    },
    onCategoryChange(value) {
      if (value && value.length > 0) {
        this.form.categoryId = value[value.length - 1]
      } else {
        this.form.categoryId = undefined
      }
    },
    onCategoryChangeShop(value) {
      this.form.shopCategoryId = value
    },
    onCrossCategoryChange(value) {
      if (value && value.length > 0) {
        this.form.crossCategoryId = value[value.length - 1]
      } else {
        this.form.crossCategoryId = undefined
      }
    },
    onSaleEndChange() {},
    onSaleEndOk() {},
    limitMaxBuyNum() {},
    limitWeight() {},
    onRefundTypeChange() {},
    multipleSpecChange() {},
    validatorSku() {},
    handlePreview(file) {
      this.previewUrl = file.url || file.thumbUrl
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 树形数据处理
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      }
      var childrenListMap = {}
      var nodeIds = {}
      var tree = []
      for (let d of data) {
        let parentId = d[config.parentId]
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = []
        }
        nodeIds[d[config.id]] = d
        childrenListMap[parentId].push(d)
      }
      for (let d of data) {
        let parentId = d[config.parentId]
        if (nodeIds[parentId] == null) {
          tree.push(d)
        }
      }
      for (let t of tree) {
        adaptToChildrenList(t)
      }
      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]]
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c)
          }
        }
      }
      return tree
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // 设置默认值
          this.form.imgIdArray = (this.form.imgList && this.form.imgList.length > 0) ? this.form.imgList.join(',') : ''

          // 多规格SKU设置默认值
          if (this.form.isMultipleSpec && this.form.skuList && this.form.skuList.length > 0) {
            this.form.skuList.forEach(sku => {
              sku.price = sku.price !== null && sku.price !== undefined ? sku.price : 0
              sku.memberPrice = sku.memberPrice !== null && sku.memberPrice !== undefined ? sku.memberPrice : 0
              sku.seckillPrice = sku.seckillPrice !== null && sku.seckillPrice !== undefined ? sku.seckillPrice : 0
              sku.activityPrice = sku.activityPrice !== null && sku.activityPrice !== undefined ? sku.activityPrice : 0
              sku.groupPrice = sku.groupPrice !== null && sku.groupPrice !== undefined ? sku.groupPrice : 0
              sku.vipPrice = sku.vipPrice !== null && sku.vipPrice !== undefined ? sku.vipPrice : 0
              sku.stock = sku.stock !== null && sku.stock !== undefined ? sku.stock : 0
              sku.weight = sku.weight !== null && sku.weight !== undefined ? sku.weight : 0
              sku.costPrice = sku.costPrice !== null && sku.costPrice !== undefined ? sku.costPrice : 0
              sku.isChangeSpec = sku.isChangeSpec !== null && sku.isChangeSpec !== undefined ? sku.isChangeSpec : false
            })
          } else if (!this.form.isMultipleSpec) {
            // 单规格设置默认值
            this.form.price = this.form.price !== null && this.form.price !== undefined ? this.form.price : 0
            this.form.stock = this.form.stock !== null && this.form.stock !== undefined ? this.form.stock : 0
            this.form.weight = this.form.weight !== null && this.form.weight !== undefined ? this.form.weight : 0
            this.form.memberPrice = this.form.memberPrice !== null && this.form.memberPrice !== undefined ? this.form.memberPrice : 0
            this.form.seckillPrice = this.form.seckillPrice !== null && this.form.seckillPrice !== undefined ? this.form.seckillPrice : 0
            this.form.activityPrice = this.form.activityPrice !== null && this.form.activityPrice !== undefined ? this.form.activityPrice : 0
            this.form.groupPrice = this.form.groupPrice !== null && this.form.groupPrice !== undefined ? this.form.groupPrice : 0
            this.form.vipPrice = this.form.vipPrice !== null && this.form.vipPrice !== undefined ? this.form.vipPrice : 0
            this.form.marketPrice = this.form.marketPrice !== null && this.form.marketPrice !== undefined ? this.form.marketPrice : 0
            this.form.costPrice = this.form.costPrice !== null && this.form.costPrice !== undefined ? this.form.costPrice : 0
            this.form.isChangeSpec = this.form.isChangeSpec !== null && this.form.isChangeSpec !== undefined ? this.form.isChangeSpec : false
          }

          updateGoods(this.form).then(response => {
            this.$message.success('保存成功')
            this.submitLoading = false
            this.handleClose()
            this.$emit('refresh')
          }).catch(error => {
            this.submitLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.loading = false
      this.form = {}
      this.categorySelected = []
    },
    handleClose() {
      this.visible = false
      this.loading = false
      this.form = {}
      this.categorySelected = []
    }
  }
}
</script>
